import httpRequest from "@/core/http-request"

//数据请求
export const roleApi = {
    saveRole(data){
        return httpRequest.post('/role/save', data)
    },
    pageRole(condition){
        return httpRequest.get('/role/page', { params: condition })
    },
    listRole(){
        return httpRequest.get('/role/list');
    },
    deleteRole(ids){
        return httpRequest.post('/role/delete', ids)
    },
    getRolePermissionIds(data){
        return httpRequest.get('/role/permission/ids',{params: data})
    },
    getRolePermissions(data){
        return httpRequest.get('/role/permissions',{params: data})
    },
}